var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecorator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 405,
    height: 322,
    viewBox: "0 0 405 322",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-129.921 320.917L85.7893 284.451L209.796 263.491C274.757 252.512 328.288 219.081 362.664 173.883C397.033 128.684 412.242 71.7223 400.062 13.5539C397.976 4.73925 387.992 -0.872168 378.137 0.793268L162.427 37.2588L38.4199 58.2189C-26.5412 69.198 -80.0717 102.629 -114.441 147.828C-148.811 193.021 -164.019 249.988 -151.846 308.15C-149.76 316.965 -139.776 322.577 -129.927 320.911L-129.921 320.917Z",
    stroke: "#E5EDF9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorator);
export default __webpack_public_path__ + "static/media/decorator.7283b83fa6423310361fb377da83494b.svg";
export { ForwardRef as ReactComponent };